import ApplicationController from './application_controller'

/**
 * Controls visibility of schedule-dependent form fields (day_of_week, day_of_month, month_of_year)
 * based on the selected schedule value (weekly, monthly, quarterly, yearly).
 *
 * Targets:
 * - weeklyFields: shown only for weekly schedule
 * - dayOfMonthFields: shown for monthly, quarterly, and yearly schedules
 * - yearlyFields: shown only for yearly schedule
 */
export default class extends ApplicationController {
  static targets = ['weeklyFields', 'dayOfMonthFields', 'yearlyFields']

  connect() {
    this.toggle()
  }

  /** Updates field visibility based on the current schedule select value. */
  toggle() {
    const schedule = this.element.querySelector('select[name*="schedule"]')?.value

    this.weeklyFieldsTarget.classList.toggle('hidden', schedule !== 'weekly')
    this.dayOfMonthFieldsTarget.classList.toggle(
      'hidden',
      !['monthly', 'quarterly', 'yearly'].includes(schedule),
    )
    this.yearlyFieldsTarget.classList.toggle('hidden', schedule !== 'yearly')
  }
}
